import { render, staticRenderFns } from "./InfoSignosVitales.vue?vue&type=template&id=b61a684c"
import script from "./InfoSignosVitales.vue?vue&type=script&lang=js"
export * from "./InfoSignosVitales.vue?vue&type=script&lang=js"
import style0 from "./InfoSignosVitales.vue?vue&type=style&index=0&id=b61a684c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports